export default "__VITE_ASSET__Dd8GHjhm__"